import AttentionWarningSvg from 'src/assets/images/attention-warning.svg';
import styled from 'styled-components';

export const AttentionWarningImage = styled(AttentionWarningSvg)`
  max-height: 18.75rem;
`;
